import {createModel} from '~~/package/utils/ModelUtil';
import Model from '~~/package/mapper/Model';

export class AssessmentCandidateSummaryModel extends Model {
  constructor(
      public assessmentInformation: AssessmentInformation = new AssessmentInformation(),
      public assessmentResultSummary: string = "",
      public userAssessmentInfo: UserAssessmentInfo = new UserAssessmentInfo(),
      public userScoreDistribution: DistributionModel = new DistributionModel(),
      public userTimeTakenDistribution: DistributionModel = new DistributionModel(),
      public assessmentSkillAcquisitionRateDistribution: DistributionModel = new DistributionModel(),
      public userSkillAcquisitionInfo: UserSkillAcquisitionInfo = new UserSkillAcquisitionInfo(),
      public trackDescriptions: TrackDescription[] = []
  ){
    super();
  }

  public static create(model: Partial<AssessmentCandidateSummaryModel>): AssessmentCandidateSummaryModel {
    return createModel<AssessmentCandidateSummaryModel>(AssessmentCandidateSummaryModel, {
      ...model
    });
  }
}

export class AssessmentInformation {
  constructor(
      public assessmentName: string = "",
      public lastRecord: string = ""
  ) {}
}

export class UserAssessmentInfo {
  constructor(
      public scoreRank: number = 0,
      public totalScoreRank: number = 0,
      public score: number = 0,
      public comparedToOverallAverage: number = 0,
      public totalTimeTaken: number = 0,
      public timeTaken: number = 0
  ) {}
}

export class UserSkillAcquisitionInfo {
  constructor(
      public skillAcquisitionRate: number = 0,
      public totalSkillAcquisitionRateRank: number = 0,
      public skillAcquisitionRateRank: number = 0,
      public comparedToOverallAverage: number = 0
  ) {}
}

export class DistributionModel {
  constructor(
      public candidateLegendValue: number = 0,
      public positionOnChart: number = -1,
      public distribution: DistributionItem[] = []
  ) {}
}

export class DistributionItem {
  constructor(
      public range: DistributionRange = new DistributionRange(),
      public percentage: number = 0,
      public count: number = 0
  ) {}
}

export class DistributionRange {
  constructor(
      public first: number = 0,
      public second: number = 0
  ) {}
}

export class TrackDescription {
  constructor(
      public trackLevelName: string = "",
      public trackName: string = "",
      public trackId: number = 0,
      public trackLevelDescription: string = ""
  ) {}
}